// extracted by mini-css-extract-plugin
export default {"wrapper":"DeaspTable_wrapper__+t1Me","wrapperBare":"DeaspTable_wrapperBare__zzsh0","header":"DeaspTable_header__CqYq0","title":"DeaspTable_title__C-M5i"};